var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorArrowDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8481 6.02726C11.9793 6.1464 11.9792 6.35274 11.8478 6.47173L6.39194 11.4131C6.1991 11.5878 5.89056 11.4509 5.89055 11.1908L5.89043 8.79365C5.89043 8.62797 5.75611 8.49366 5.59043 8.49366H1.175C1.00932 8.49366 0.875 8.35935 0.875 8.19366L0.875 4.29366C0.875 4.12798 1.00931 3.99366 1.175 3.99366H5.59073C5.75642 3.99366 5.89074 3.85934 5.89073 3.69365L5.89062 1.29594C5.8906 1.03558 6.19951 0.898797 6.39228 1.07381L11.8481 6.02726Z",
    fill: "#E4E4EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorArrowDesktop);
export default __webpack_public_path__ + "static/media/VectorArrowDesktop.a917ffb28a1ce7cc8a8b4b3442b306a1.svg";
export { ForwardRef as ReactComponent };